import React, { Component } from 'react';
import { connect } from 'react-redux';
import HalfImage from '../../../views/components/home/HalfImage';
import Comparacion from '../../../views/components/home/Comparacion';
import Testimonial from '../../../views/components/home/Testimonials';
import CotizaYa from '../../../views/components/home/CotizaYa';
import Servicio from '../../../views/components/home/Servicio'
import Recolectamos from '../../../assets/images/recolectamos_tus_cosas.png'
import FormaSegura from '../../../assets/images/forma-segura.png'
import EntregaCuandoDigas from '../../../assets/images/entrega-cuando-digas.png'
import { StyleSheet, css } from 'aphrodite';
import VizSensor from 'react-visibility-sensor';
import Hero from './Hero';
import HeroForm from './HeroForm';
import API from '../../../api'
import { UI } from '../../../store/actions'

const api = new API();
const styles = StyleSheet.create({
    title: {
        color: '#193f83',
        fontWeight: 700,
        textAlign: 'center'
    }
});


function mapStateToProps(state) {
    return {

    };
}

class HomeAB extends Component {

    constructor(props){
        super(props);

        this.state= {
            fbTracked: false
        }

        window.mixpanel.track('Landings',{
            'site': props.site,
            'variation': props.variation,
        })

        api.landings.registerVisit(props.site,props.variation,props.online_to);
    }

    handleScrollBottom = () =>{
        if(!this.state.fbTracked){
            window.fbq('track','ViewContent')
            this.setState({fbTracked: true})
        }
        
    }

    setLoading =(isLoading)  => {
        this.props.dispatch(UI.setLoading(isLoading));
    }

    render() {
        return (
            <div>
                {this.props.variation == 'control' &&
                    <Hero setLoading={this.setLoading} {...this.props} />
                }
                {this.props.variation == 'form' &&
                    <HeroForm setLoading={this.setLoading} {...this.props} />
                }
                <Servicio />
                {/* <HalfImage /> */}
                <Testimonial />
                <Comparacion/>
                <VizSensor
                    onChange={(isVisible) => {
                        if(isVisible){
                            this.handleScrollBottom();
                        }
                    }}
                >
                    <CotizaYa />
                </VizSensor>
                
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
)(HomeAB);